/**
 * Created by Sergey Shoshin on 2017-04-29.
 */
import ErrorModel from '../models/system/error';
import {CookieService} from 'angular2-cookie/core';
import {Injectable} from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable()
export class KartinaErrorsService {
    private readonly updateSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
    public update: Observable<string> = this.updateSubject.asObservable();

    constructor(private readonly cookiesService: CookieService) {
    }

    public async checkError(error: ErrorModel): Promise<void> {
        if (!!error && error.code > 0) {
            return;
        }
    }

    public updateMessage(message: string): void {
        if (!!message) {
            this.cookiesService.put('system-message', message);
            this.updateSubject.next(message);
        } else {
            this.cookiesService.remove('system-message');
            this.updateSubject.next('');
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/services/kartina-errors-service.ts